import { fieldTypes } from './field-types';
import { initializeFieldCategoryMapping } from './initialize-field-category-mapping';
export var ConversionCompatibility;
(function (ConversionCompatibility) {
    ConversionCompatibility["never"] = "never";
    ConversionCompatibility["always"] = "always";
    ConversionCompatibility["sometimes"] = "sometimes";
})(ConversionCompatibility || (ConversionCompatibility = {}));
/**
 * Can a field be converted to a different type without data loss.
 *
 * returns:
 * * 'never' if the conversion will result in complete loss of data.
 * * 'sometimes' if the conversion may result in data loss.
 * * 'always' if the conversion can be done with no loss of data at all.
 * @param {string} fromFieldType
 * @param {string} toFieldType
 * @returns {ConversionCompatibility}
 */
export const canConvertFieldTypeWithoutDataLoss = (fromFieldType, toFieldType) => {
    var _a, _b;
    const categoryMappings = initializeFieldCategoryMapping();
    if (!categoryMappings[fromFieldType] || !fieldTypes[categoryMappings[fromFieldType]]) {
        return ConversionCompatibility.never;
    }
    const category = fieldTypes[categoryMappings[fromFieldType]];
    const findFieldType = category.find((field) => field.type === fromFieldType);
    if ((_a = findFieldType === null || findFieldType === void 0 ? void 0 : findFieldType.conversions) === null || _a === void 0 ? void 0 : _a.always.includes(toFieldType)) {
        return ConversionCompatibility.always;
    }
    if ((_b = findFieldType === null || findFieldType === void 0 ? void 0 : findFieldType.conversions) === null || _b === void 0 ? void 0 : _b.sometimes.includes(toFieldType)) {
        return ConversionCompatibility.sometimes;
    }
    return ConversionCompatibility.never;
};
